import {
  CARACTERISTICA_CLIENTE_CREATE,
  CARACTERISTICA_CLIENTE_DELETE,
  CARACTERISTICA_CLIENTE_LOAD,
  CARACTERISTICA_CLIENTE_UPDATE,
  CARACTERISTICA_CLIENTE_LIST
} from "../actions/caracteristicaCliente";
import { ERRORS_SHOW } from "../actions/errors";
import Api from "../../service/api-web";

const state = { list: [] };

const getters = {
  getListCaracteristicasCliente: state => state.list || []
};

const actions = {
  [CARACTERISTICA_CLIENTE_CREATE]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.cliente.caracteristic
        .adiciona(getters.getFornecedorId, payload)
        .then(resp => resolve(resp.data))
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [CARACTERISTICA_CLIENTE_DELETE]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.cliente.caracteristic
        .remove(getters.getFornecedorId, payload)
        .then(resolve)
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [CARACTERISTICA_CLIENTE_LOAD]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.cliente.caracteristic
        .get(getters.getFornecedorId, payload)
        .then(resp => resolve(resp.data))
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [CARACTERISTICA_CLIENTE_UPDATE]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.cliente.caracteristic
        .atualiza(getters.getFornecedorId, payload.idcaracteristica, payload)
        .then(resp => resolve(resp.data))
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [CARACTERISTICA_CLIENTE_LIST]: ({ dispatch, commit, getters }) => {
    return new Promise((resolve, reject) => {
      Api.v4.cliente.caracteristic
        .list(getters.getFornecedorId)
        .then(resp => {
          commit(CARACTERISTICA_CLIENTE_LIST, resp.data);
          resolve(resp);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  }
};

const mutations = {
  [CARACTERISTICA_CLIENTE_LIST]: (state, payload) => {
    state.list = payload || [];
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
